import * as React from 'react';
import { PhotoViewerConstants as ui } from '../../Config/UIConstants';
import { RemovalConfirmationPopup } from '../RemovalConfirmationPopup';

export interface IAcceptsDeferredLeaveAction {
    onTryNavigate(isDirty: boolean, leaveAction: () => void): void;
}

interface IState {
    deferredLeaveAction?(): void;
}

// https://stackoverflow.com/a/41112882/93345
export const warnBeforeDelete = <P extends {}>(WrappedComponent: React.ComponentType<P & IAcceptsDeferredLeaveAction>): React.ComponentType<Exclude<P, IAcceptsDeferredLeaveAction>> =>
    class WarnsBeforeDelete extends React.Component<Exclude<P, IAcceptsDeferredLeaveAction>, IState> {
        public state: IState = {
            deferredLeaveAction: undefined
        };

        private onTryNavigate = (isDirty: boolean, leaveAction: () => void): void => {
            if (isDirty) {
                this.setState({
                    deferredLeaveAction: leaveAction,
                });
            } else {
                leaveAction();
            }
        }

        private onFulfillDeferredLeaveAction = (): void => {
            const leaveAction = this.state.deferredLeaveAction!;

            this.deleteDeferredLeave();

            leaveAction();
        }

        private deleteDeferredLeave = (): void => {
            this.setState({
                deferredLeaveAction: undefined
            });
        }

        public render(): React.ReactNode {
            return (<React.Fragment>
                <WrappedComponent onTryNavigate={this.onTryNavigate} {...this.state} {...this.props}/>

                {this.state.deferredLeaveAction && (
                    <RemovalConfirmationPopup
                        cancelText={ui.EXIT_CANCEL}
                        removeText={ui.DELETE_UNADDED_DATA}
                        onClickCancel={this.deleteDeferredLeave}
                        onClickRemove={this.onFulfillDeferredLeaveAction}
                        headerText={ui.NOT_FINISHED_COMMENT_HEADER}
                        subHeaderText={ui.NOT_FINISHED_COMMENT_SUB_HEADER}
                    />
                )}
            </React.Fragment>);
        }
    };



// WEBPACK FOOTER //
// ./src/SharedComponents/HigherOrderComponents/WarnsBeforeDelete.tsx